// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.disabled {\n  opacity: .3;\n}\n.color-danger {\n  background-color: #F56C6C;\n  color: white;\n}\n.el-form--label-top .el-form-item__label {\n  padding-bottom: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
